import { Inject, Injectable } from '@angular/core'
import { AUTH_CONFIGURATION, AuthConfiguration } from '@ftr/api-shared'
import { COOKIE_STORAGE_SETTINGS } from '@ftr/foundation'
import { CognitoUser, CookieStorage, ICookieStorageData } from 'amazon-cognito-identity-js'
import { AuthTokenStorageService } from '../auth-token-storage'

export const COGNITO_COOKIE_STORAGE = new CookieStorage({ ...COOKIE_STORAGE_SETTINGS } as ICookieStorageData)

@Injectable({
  providedIn: 'root',
})
export class CognitoUserFactory {
  constructor(
    @Inject(AUTH_CONFIGURATION) readonly configurationService: AuthConfiguration,
    private readonly authTokenStorageService: AuthTokenStorageService,
  ) {}

  create(username: string): CognitoUser {
    return this.authTokenStorageService.isCookieStorage()
      ? new CognitoUser({
          Username: username.toLowerCase(),
          Pool: this.configurationService.cookieBasedUserPool,
          Storage: COGNITO_COOKIE_STORAGE,
        })
      : new CognitoUser({
          Username: username.toLowerCase(),
          Pool: this.configurationService.userPool,
        })
  }
}
